import { AnyAction } from "redux";
import {
  FETCH_ABOUT_US_PAGE_ERROR,
  FETCH_ABOUT_US_PAGE_SUCCESS,
  REQUEST_FETCH_ABOUT_US_PAGE,
} from "redux/actions/pages/aboutus";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_ABOUT_US_PAGE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ABOUT_US_PAGE_SUCCESS:
      return {
        data: action.aboutUs,
        error: null,
        loading: false,
      };
    case FETCH_ABOUT_US_PAGE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
